import React, { Component } from 'react';
import { withStyles, Card, CardHeader, CardContent, Divider, Button } from '@material-ui/core';
import { GetData } from '../../api/service';

const styles = theme => ({

})

class LaboratoryView extends Component {
    state = {
        labs: [],
        isLoaded: false
    }

    componentDidMount() {
      GetData(`/getlaboratory`)
      .then((resp) => {
          //console.log(resp)
          this.setState({
              isLoaded: true,
              labs: resp
          })
      })
    }
    
    render() {
        let {classes} = this.props;
        return (
            <div>
                {this.state.isLoaded ? (
                    <div>
                        {this.state.labs.map((el,index) => 
                            
                            <div key={index}>

                                <Card>
                                    <CardHeader
                                        title={el.lab_name}
                                        subheader={`Semester: ${el.semester}`}
                                    />
                                    <CardContent>
                                        Description: 
                                        <p dangerouslySetInnerHTML={{__html: el.description}}></p>

                                        <Divider />

                                        Experiments:
                                        <p dangerouslySetInnerHTML={{ __html: el.lab_experiments }}></p>

                                        <Divider />

                                        Lab Manual Download: 

                                        {el.lab_manual.map((el1,index1) => 

                                                <Button
                                                    key={index1}
                                                    color="primary"
                                                    size="small"
                                                >
                                                    Lab Manual {index1+1}
                                                </Button>
                                            
                                            )}
                                    </CardContent>
                                </Card>

                            </div>
                            
                            )}
                    </div>
                ) : 'Loading . . '}
            </div>
        );
    }
}

export default withStyles(styles)(LaboratoryView);


// WEBPACK FOOTER //
// ./src/Components/Laboratory/LaboratoryView.js